import { render } from "./Gallery.vue?vue&type=template&id=8dfadd2e"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=8dfadd2e&lang=css"
import "./Gallery.vue?vue&type=style&index=1&id=8dfadd2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__